import { Component, ElementRef, Input, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { BasePageComponent } from '../../base-page/base-page.component';
import { UserCampaignService } from 'src/app/services/campaigns/campaign.service';
import { distinctUntilChanged, map, switchMap, takeUntil } from 'rxjs';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';

const confirmationMsg: string = $localize`:@@tournamentRebuyBonusConfirmationMsg:Are you sure you want to rebuy mission's bonus?`;


@Component({
  selector: 'app-main-reactivation',
  templateUrl: './main-reactivation.component.html',
  styleUrls: ['./main-reactivation.component.scss']
})
export class MainReactivationComponent extends BasePageComponent {
  reactivationData: any;
  @ViewChildren('reactivationcardElement') reactivationcardElements: QueryList<ElementRef>;

  constructor(
    public userCampaignService: UserCampaignService,
    public detectDeviceService: DetectDeviceService,
    private loginStatus: LoginStatusService,

  ) { super() }
  @Input() recData: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.reactivationData) {
      console.log('Reactivation Data:', this.reactivationData);
    }
  }



  ngOnInit(): void {
    this.loginStatus.getIfUserLogged().pipe(
      distinctUntilChanged(),
      switchMap((status) => {
        return this.userCampaignService.getActiveCampaign()
      })
    ).subscribe(resp => {
      if (!resp.campaign.name.toLowerCase().includes('xmas')) {
        this.reactivationData = resp;
      }
      setTimeout(() => {
        this.scrollToActiveCard();
      }, 0);
    })
  }

  scrollToActiveCard() {
    if (this.reactivationcardElements && this.reactivationcardElements.length > 0) {
      const activeCard = this.reactivationcardElements.toArray().find((card, index) => {
        return card.nativeElement.classList.contains('active-scrollTop-card');
      });
      if (activeCard) {
        activeCard.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

}
